module.exports = __webpack_public_path__ + "static/media/networkingM.6fe37be9.jpg";